var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-box first"},[_c('div',{staticClass:"fadada-box"},[_c('div',{staticClass:"url-box"},[_c('iframe',{attrs:{"src":_vm.iframeUrl,"scrolling":"no","frameborder":"0"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }